<div class="asset-upload-container h-full">
  <thehubz-asset-settings-stepper
    #stepper
    [class.has-left-area]="stepperDataObj.stepperData.leftArea?.includes(currentStep.stepperGroupName) || false"
    [stepperModel]="stepperDataObj"
    [taggingOptions]="taggingOptions"
    [assetLists]="assetLists"
    [brandingKey]="brandingKey"
    (stepChange)="currentStep = $event"
    (formSubmit)="updateAssetBuyout($event)"
    (deletedBuyoutRightIndex)="deleteAssetBuyoutRight($event)"
    (deletedBuyoutRightTerritoryIndex)="handleAssetBuyoutRightTerritoryRemoval($event)"
  >
    <div *ngIf="stepperDataObj.stepperData.leftArea?.includes(currentStep.stepperGroupName) || false" leftAreaSlot class="overflow-y-auto widget-bg-color">
      <div *ngIf="assetLists && assetLists.length; else noFilesAdded" class="asset-preivew" style="--asset-item-padding: 0.7rem; --asset-item-gap: 1rem">
        <header class="asset-preview-header widget-bg-color">
          <span class="header-column" i18n>Asset</span>
          <span class="header-column name-column" i18n>Name</span>
          <span class="header-column type-column" i18n>Type</span>
        </header>

        <ol class="asset-preview-list">
          <li *ngFor="let file of assetLists" class="asset-preview-item">
            <thehubz-asset-item-basic [item]="file" [editFlag]="true" class="elevated rounded"></thehubz-asset-item-basic>
          </li>
        </ol>
      </div>

      <ng-template #noFilesAdded>
        <div class="flex w-full h-full justify-center items-center" i18n>No files selected</div>
      </ng-template>
    </div>
    <ng-template let-formValue let-dateMultiEditText="datePlaceHolder" #reviewAndSubmit>
      @if (brandingKey === CustomClients.Standard) {
        <thehubz-buyout-rights-standard
          [formValue]="formValue.usageRightsGeneralInformation"
          [buyoutRightsConfigs]="buyoutRightsConfigs"
          [columns]="columns"
          [dateMultiEditText]="dateMultiEditText"
        ></thehubz-buyout-rights-standard>
      } @else {
        <thehubz-buyout-rights-custom
          [formValue]="formValue"
          [buyoutRightsConfigs]="buyoutRightsConfigs"
          [columns]="columns"
          [dateMultiEditText]="dateMultiEditText"
          [notesColumnName]="notesColumnName"
        ></thehubz-buyout-rights-custom>
      }
    </ng-template>
  </thehubz-asset-settings-stepper>
</div>
